/* eslint-disable no-undef */
import '../public/styles.css'
import '@babel/polyfill'
import header from './components/header'
import about from './components/about'
import { sectionProyects as proyects } from './components/sectionProyects'
import contact from './components/contact'
import Nav from './services/nav'
import ErrorApi from './components/errorApi'
import AddEventTargert from './services/addEventTarget'
import EventAnalitic from './services/EventAnalitic'
import FetchApi from './services/fetchApi'
const fetchApi = new FetchApi()

fetchApi.fetchGetApi().then((state) => {
  if (state.status === false) {
    const App = ErrorApi
    // eslint-disable-next-line no-undef
    document.querySelector('#root').innerHTML = App
  } else {
    state.data.then((state) => {
      const App =
        header(state) + about(state) + proyects(state) + contact(state)

      // eslint-disable-next-line no-undef
      document.querySelector('#root').innerHTML = App

      // anilitica

      const $about = document.querySelector('#about')
      const $proyect = document.querySelector('#proyect')
      const $contact = document.querySelector('#contact')
      const $navItems = document.querySelectorAll('nav ul li a')
      const $socialItems = document.querySelectorAll(
        '.hero-about ul li a'
      )
      const $dowloaderCV = document.querySelector('#about a')
      const $linksProyects = document.querySelectorAll(
        '#proyect article a'
      )
      const $contactItems = document.querySelectorAll('#contact ul a')
      const $articlesProyect = document.querySelectorAll(
        '#proyect article'
      )

      const addEvent = new AddEventTargert()
      const eventAnalitic = new EventAnalitic()

      // event get in about
      addEvent.addEvent($about, 'mouseover', () =>
        eventAnalitic.eventAnalitic(
          'onmouseover',
          'getIn about',
          'getIn about'
        )
      )

      // event get in proyect
      addEvent.addEvent($proyect, 'mouseover', () =>
        eventAnalitic.eventAnalitic(
          'onmouseover',
          'getIn proyct',
          'getIn proyect'
        )
      )

      // event get in Contact
      addEvent.addEvent($contact, 'mouseover', () =>
        eventAnalitic.eventAnalitic(
          'onmouseover',
          'getIn Contact',
          'getIn Contact'
        )
      )

      // event click nav items

      $navItems.forEach(($navItem) =>
        addEvent.addEvent($navItem, 'click', () =>
          eventAnalitic.eventAnalitic(
            'click',
            `clickNavItems ${$navItem.parentElement.id}`,
            `clickNavItems ${$navItem.parentElement.id}`
          )
        )
      )

      // get in social networks

      $socialItems.forEach(($socialItem) =>
        addEvent.addEvent($socialItem, 'click', () =>
          eventAnalitic.eventAnalitic(
            'click',
            `clickSocialItems ${$socialItem}`,
            `clickSocialItems ${$socialItem}`
          )
        )
      )

      // dowloader CV

      addEvent.addEvent($dowloaderCV, 'click', () =>
        eventAnalitic.eventAnalitic(
          'click',
          'dowloader cv',
          'dowloader CV'
        )
      )

      // proyect
      $linksProyects.forEach(($linkProyect) => {
        const nameProyect = $linkProyect.parentElement.parentElement.querySelector(
          'h4'
        ).textContent
        addEvent.addEvent($linkProyect, 'click', () =>
          eventAnalitic.eventAnalitic(
            'click',
            `click ${$linkProyect.text} Proyect ${nameProyect}`,
            `click ${$linkProyect.text} Proyect ${nameProyect}`
          )
        )
      })

      // contact
      $contactItems.forEach(($contactItem) =>
        addEvent.addEvent($contactItem, 'click', () =>
          eventAnalitic.eventAnalitic(
            'click',
            `click contact ${$contactItem}`,
            `click contact ${$contactItem}`
          )
        )
      )

      // event get in article proyect

      $articlesProyect.forEach(($articleProyect) => {
        const nameProyect = $articleProyect.querySelector('h4')
          .innerText
        addEvent.addEvent($articleProyect, 'mouseover', () =>
          eventAnalitic.eventAnalitic(
            'onmouseover',
            `get in Proyect ${nameProyect}`,
            `get in Proyect ${nameProyect}`
          )
        )
      })

      /// ////////////////

      /** Nav */
      if (window.matchMedia('(max-width: 768px)').matches) {
        const nav = new Nav()
        const addEvent = new AddEventTargert()
        /* add event nav */
        const $nav = document.querySelector('nav')
        const $iconMenu = document.querySelector('.icon-menu')
        const $iconClose = document.querySelector('.icon-close')
        const $itemNav = document.querySelectorAll('nav ul li a')
        const $hero = document.querySelector('#hero')

        addEvent.addEvent($iconMenu, 'click', () =>
          nav.handleToggleVisibilityNav({
            $nav,
            $iconMenu,
            $iconClose,
            $hero
          })
        )
        addEvent.addEvent($iconClose, 'click', () => {
          nav.handleToggleVisibilityNav({
            $nav,
            $iconMenu,
            $iconClose,
            $hero
          })
        })

        /* add event item nav */
        $itemNav.forEach(($item) => {
          addEvent.addEvent($item, 'click', () => {
            nav.handleToggleVisibilityNav({
              $nav,
              $iconMenu,
              $iconClose
            })
          })
        })
      }
    })
  }
})
